import { Component, Input, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "app-all-seeing-eye",
  template: `
    <mat-form-field class="{{ class }}">
      <mat-label>{{ label }}</mat-label>
      <input
        matInput
        [type]="showPassword ? 'text' : 'password'"
        autocomplete="new-password"
        (blur)="handleBlur()"
        [value]="value"
        (input)="onInputChange($event)"
        id="password-input" />
      <mat-icon matSuffix id="password-show-input" (click)="togglePassword()" (mousedown)="$event.preventDefault()">
        {{ showPassword ? "visibility" : "visibility_off" }}
      </mat-icon>
      <mat-hint align="start" *ngIf="hintText != null">{{ hintText }}</mat-hint>
      <mat-icon *ngIf="helpText != null" matSuffix matTooltip="{{ helpText }}" (mousedown)="$event.preventDefault()">help</mat-icon>
    </mat-form-field>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AllSeeingEyeComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class AllSeeingEyeComponent implements ControlValueAccessor {
  @Input() value: string;
  @Input() helpText: string = null;
  @Input() hintText: string = null;
  @Input() class = "min-w-px-300";
  @Input() label = "Password";
  @Input() onBlur: () => void = () => undefined;
  showPassword = false;

  onChange: (value: string) => void = (() => undefined) as (value: string) => void;
  onTouched = () => undefined;

  writeValue(value: string | null): void {
    this.value = value ?? "";
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  handleBlur(): void {
    this.onTouched();
    this.onBlur();
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value);
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }
}
